import React, { useEffect, useState } from 'react';
import {  auth, db, storage, firestore } from '../../firebase/firebase';
import { Link, useNavigate } from "react-router-dom";
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import RegistrationWizard from './RegistrationWizard';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useTranslation } from 'react-i18next';

var signingOnce = false;

export default function CompleteRegistration({modal}) {
  const [verified, setVerified] = useState(false);
  const [newVUser, setnewVUser] = useState(null);
  const [email, setEmail] = useState('');
    const navigate = useNavigate(); 
  const { t } = useTranslation();
  const { notify } = useNotifications();
  useEffect(() => {
    const storedEmail = window.localStorage.getItem('emailForSignIn');
    const url = window.location.href;

    if (!storedEmail) {
      notify('error', 'No email stored. Restart registration.');
	  navigate('/register');
      return;
    }

    if (signingOnce == false && isSignInWithEmailLink(auth, url)) {
	  signingOnce = true;
      signInWithEmailLink(auth, storedEmail, url).then((result) => {
          console.log("Signed in as:", result.user.email);
		  setnewVUser(result.user);
		  window.localStorage.removeItem('emailForSignIn');
          setEmail(storedEmail);
          setVerified(true);
        })
        .catch((err) => {
          console.error(err);
          notify('error', err.message);
        });
    }
  }, []);

  if (!verified) {
    return <div style={{ color: 'white', textAlign: 'center', marginTop: '4rem' }}>{t('verification.verify')}</div>;
  }

  return <RegistrationWizard modal={modal} preFilledEmail={email} newUser={newVUser}/>;
}
